<app-modal *ngIf="vo$ | async; let vo">
	<app-panel
		modal-body
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		[itemsCount]="vo.historyList.elements.size"
		hasRefresh="true"
		(search)="search($event)"
		(refresh)="refresh()">
		<span
			panel-title
			i18n="@@subscription.history.list.title">
			history
		</span>
		<dx-data-grid
			keyExpr="id"
			[elementAttr]="{
			id: 'history-list',
			class: 'app-history-list'}"
			[repaintChangesOnly]="true"
			[dataSource]="vo.historyList.elements | toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="false"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[width]="'100%'">

			<dxo-header-filter [visible]="true"></dxo-header-filter>

			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<ng-container
				*ngFor="let col of vo.historyList.availableColumns | toArray">

				<dxi-column
					*ngIf="col.field === 'status'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[format]="col.format"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[width]="100"
					cellTemplate="statusTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'action'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[type]="col.type"
					[format]="col.format"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					cellTemplate="actionTemplate"
					[width]="'20%'"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'columnCount'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable ?? false"
					[allowSorting]="true"
					[format]="col.format"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					cellTemplate="columnCountTemplate"
					[width]="200"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'lineCount'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[width]="180"
					cellTemplate="lineCountTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'date'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[dataType]="col.type"
					[format]="col.format"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					cellTemplate="dateTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'duration'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[type]="col.type"
					[format]="col.format"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					cellTemplate="durationTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'avatar'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[type]="col.type"
					[format]="col.format"
					[visibleIndex]="col.visibleIndex"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[width]="140"
					cellTemplate="avatarTemplate"></dxi-column>
			</ng-container>

			<div *dxTemplate="let cell of 'statusTemplate'">
				<app-status-badge
					[status]="cell.data['status']"></app-status-badge>
			</div>

			<div *dxTemplate="let cell of 'actionTemplate'">
				 {{cell.data['action']}}
			</div>

			<div *dxTemplate="let cell of 'columnCountTemplate'">
				<app-overlay-badge
					[icon]="ComponentIcons.Column"
					[value]="cell.data['columnCount']"
					[active]="false"></app-overlay-badge>
			</div>

			<div *dxTemplate="let cell of 'lineCountTemplate'">
				<app-overlay-badge
					[icon]="ComponentIcons.Data"
					[value]="cell.data['lineCount']"
					[active]="false"></app-overlay-badge>
			</div>

			<div *dxTemplate="let cell of 'dateTemplate'">
				<span
					*ngIf="cell.data['date']">
					{{ cell.data['date'] | dayjsDate: 'DateTime' }}
				</span>
			</div>

			<div *dxTemplate="let cell of 'durationTemplate'">
				<span
					*ngIf="cell.data['duration']">
					{{cell.data['duration'] | dayjsDurationFormat }}
				</span>
				<span
					*ngIf="!cell.data['duration']">
					0s</span>
			</div>

			<div *dxTemplate="let cell of 'avatarTemplate'">
				<app-avatar
					*ngIf="cell.data['avatar']"
					[avatar]="cell.data['avatar']"
					[withTooltip]="true"></app-avatar>
			</div>

		</dx-data-grid>
	</app-panel>
</app-modal>
